import {
    createRouter,
    createWebHistory,
    createWebHashHistory,
} from "vue-router";

const routes = [
    {
        path: "/",
        redirect: "/index",
    },
    {
        path: "/index",
        component: () => import("../views/weather/index.vue"),
    },
    {
        path: "/map",
        component: () => import("../views/map/Index.vue"),
    },
    {
        path: "/services",
        component: () => import("../views/index/index.vue"),
    },
    {
        path: "/calendar",
        component: () => import("../views/calendar/Index.vue"),
    },
    {
        path: "/air",
        component: () => import("../views/air/index.vue"),
    },
    {
        path: "/warning",
        component: () => import("../views/warning/index.vue"),
    },
    {
        path: "/astronomy",
        component: () => import("../views/astronomy/index.vue"),
    },
    {
        path: "/typhoon",
        component: () => import("../views/typhoon/Index.vue"),
    },
    {
        path: "/flower",
        component: () => import("../views/flower/Index.vue"),
    },
    {
        path: "/news",
        component: () => import("../views/news/index.vue")
    },
    {
        path: "/about",
        name: "about",
        component: () => import("../views/about/index.vue"),
    },
    {
        path: "/article", // 资讯
        component: () => import("../views/article/article.vue"),
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.query.scrollId !== 'contact') {
            return { top: 0 };
        }
    },
});
router.beforeEach((to, from, next) => {
    if (to.name !== 'about' && to.query.scrollId) {
        const { scrollId, ...otherParams } = to.query;
        next({
            path: to.path,
            query: otherParams,
        });
    } else {
        next();
    }
});

export default router;
